import { IRegularInfrastructureData, ITAInfrastructureData, TTAInfrastructureType } from '../../../types/map';

export const findGeoObjectDatum = (
  geoObjectId: string,
  regularInfrastructureByYear: Map<number, IRegularInfrastructureData>,
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
) => {
  const yearInfrastructures = Array.from(regularInfrastructureByYear.values());

  for (const { geoObjectsData } of yearInfrastructures) {
    for (const datum of geoObjectsData) {
      if (datum.geoObject.options.id === geoObjectId) {
        return datum;
      }
    }
  }

  const infrastructuresByTypes = Array.from(transportAccessibilityInfrastructureByType.values());

  for (const { geoObjectsData } of infrastructuresByTypes) {
    for (const datum of geoObjectsData) {
      if (datum.geoObject.options.id === geoObjectId) {
        return datum;
      }
    }
  }

  return null;
};
